module.exports = __webpack_public_path__ + "static/media/welcome.e2e22b56.jpg";